<wiz-hgroup #hgContainer height="100%" width="100%" verticalAlign="center" gap="10" style="justify-content: center">
  <wiz-image [sourceObservable]="cnx.iconOrDie" width="24px" height="24px"></wiz-image>
</wiz-hgroup>
